import { useTranslator } from '@bluebeam/react-i18n';
import BluebeamLogo from 'components/Icons/BluebeamLogo';
import ProjectRoverHeader from 'components/Icons/ProjectRoverHeader';
import { environmentVars } from 'constants/services';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';
import React, { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import IndexLanguage from './IndexLanguage';
import RegionSelector from './RegionSelector';

interface Props {
  queryParams: string;
  showSignInButton?: boolean;
}

const IndexHeader: FC<Props> = ({
  queryParams,
  showSignInButton = true,
}): ReactElement => {
  const { translate } = useTranslator(['buttons', 'index']);
  const { [FeatureFlag.RegionDropdown]: isRegionDropdownEnabled } =
    useFeatureFlags();

  return (
    <header className="bgd-white index-header">
      <div className="index__container">
        <div
          className="w100 flex items-center justify-between"
          style={{ height: '78px' }}
        >
          <span>
            {Boolean(environmentVars.BB_BRANDING) === false ? (
              <ProjectRoverHeader width="206px" theme="landing" />
            ) : (
              <BluebeamLogo theme="light" location="landing" width={209} />
            )}
          </span>
          <div
            className="flex items-center"
            style={{ flexBasis: '30em', justifyContent: 'right' }}
          >
            {isRegionDropdownEnabled ? (
              <>
                <div className="pr2">{translate('index:selectRegion')}</div>
                <div className="pr4" style={{ flexBasis: '10em' }}>
                  <RegionSelector />
                </div>
              </>
            ) : (
              <>
                <div className="pr4">
                  <IndexLanguage />
                </div>
              </>
            )}
            {showSignInButton && (
              <Link
                to={`/my-workspace${queryParams}`}
                className="btn-sm bold px3 py1 decoration-none flex-center"
                style={{ backgroundColor: '#0083DB', borderRadius: '3px' }}
                id="header-sign-in"
              >
                {translate('buttons:signIn')}
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default IndexHeader;
